if (!customElements.get('cart-navigation')) {
  class CartNavigation extends HTMLElement {
    constructor() {
      super();
      this.bindOnResize = this.onResize.bind(this);
      this.bindOnMouseDown = this.onMouseDown.bind(this);
      this.bindOnMouseUp = this.onMouseUp.bind(this);
      this.bindOnMouseMove = this.onMouseMove.bind(this);
    }

    connectedCallback() {
      this.list = this.querySelector('.cart-navigation__list');
      this.items = this.querySelectorAll('.cart-navigation__item');

      if (!this.list || this.items.length <= 0) return;

      this.onResize();
      window.addEventListener('resize', this.bindOnResize);
    }

    onResize() {
      if (this.list.getBoundingClientRect().width < this.itemsWidth) {
        this.list.classList.add('overflowed');
        this.handleScroll();
      } else {
        this.list.classList.remove('overflowed');
        this.removeScroll();
      }
    }

    handleScroll() {
      this.isDown = false;
      this.startX = 0;
      this.initScrollLeft = this.list.scrollLeft;

      this.list.addEventListener('mousedown', this.bindOnMouseDown, { passive: false });
    }

    removeScroll() {
      this.list.removeEventListener('mousedown', this.bindOnMouseDown, { passive: false });
    }

    onMouseDown(event) {
      event.preventDefault();
      this.list.classList.add('grabbing');
      this.isDown = true;
      this.startX = event.pageX - this.list.offsetLeft;
      this.initScrollLeft = this.list.scrollLeft;

      this.list.addEventListener('mouseleave', this.bindOnMouseUp, { passive: false });
      this.list.addEventListener('mouseup', this.bindOnMouseUp, { passive: false });
      this.list.addEventListener('mousemove', this.bindOnMouseMove, { passive: false });
    }

    onMouseMove(event) {
      event.preventDefault();
      if (!this.isDown) return;
      this.list.classList.add('moving');
      const x = event.pageX - this.list.offsetLeft;
      const walk = x - this.startX;
      this.list.scrollLeft = this.initScrollLeft - walk;
    }

    onMouseUp() {
      this.isDown = false;
      this.list.classList.remove('grabbing', 'moving');

      this.list.removeEventListener('mouseleave', this.bindOnMouseUp, { passive: false });
      this.list.removeEventListener('mouseup', this.bindOnMouseUp, { passive: false });
      this.list.removeEventListener('mousemove', this.bindOnMouseMove, { passive: false });
    }

    get itemsWidth() {
      const computedStyles = getComputedStyle(this.list);
      const gap = computePixelValue(computedStyles.columnGap) || computePixelValue(computedStyles.gap) || 0;
      let width = 0;
      this.items.forEach((item, index) => {
        width += item.getBoundingClientRect().width;
        if (index > 0) {
          width += gap;
        }
      });

      return width;
    }
  }

  customElements.define('cart-navigation', CartNavigation)
}